import GifCard from './GifCard'

export default GifCard



// WEBPACK FOOTER //
// ./src/components/GifCard/index.js